var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('label',{staticClass:"switch",on:{"click":function($event){return _vm.updateValue()}}},[_c('span',{staticClass:"slider",class:{ enabled: _vm.transformedValue }})])])
}
var staticRenderFns = []

export { render, staticRenderFns }